import React from 'react';

import { EmployersListPageLayout } from './EmployersListPageLayout';

const EmployersListPageContainer: React.FC = () => {

	return (
		<React.Fragment>
			<EmployersListPageLayout/>
		</React.Fragment>
	);
};

export default EmployersListPageContainer;